const todayMin = new Date();
todayMin.setUTCHours(0, 0, 0, 0);
export const todayMinString =
    encodeURIComponent(todayMin.toISOString().split(".")[0]) + "%2B02%3A00";

const todayMax = new Date();
todayMax.setUTCHours(23, 59, 59, 999);
export const todayMaxString =
    encodeURIComponent(todayMax.toISOString().split(".")[0]) + "%2B02%3A00";

const today = new Date();

const saturday = today.getDate() - today.getDay() + 6;
const saturdayMin = new Date(today.setDate(saturday));
saturdayMin.setUTCHours(0, 0, 0, 0);
export const saturdayMinString =
    encodeURIComponent(saturdayMin.toISOString().split(".")[0]) +
    "%2B02%3A00";

const sunday = today.getDate() - today.getDay() + 7;
const sundayMax = new Date(today.setDate(sunday));
sundayMax.setUTCHours(23, 59, 59, 999);
export const sundayMaxString =
    encodeURIComponent(sundayMax.toISOString().split(".")[0]) +
    "%2B02%3A00";

const current = new Date();

const addSevenMax = new Date();
addSevenMax.setDate(current.getDate() + 7);
addSevenMax.setUTCHours(23, 59, 59, 999);
export const addSevenMaxString =
    encodeURIComponent(addSevenMax.toISOString().split(".")[0]) +
    "%2B02%3A00";

const addFourteenMax = new Date();
addFourteenMax.setDate(current.getDate() + 14);
addFourteenMax.setUTCHours(23, 59, 59, 999);
export const addFourteenMaxString =
    encodeURIComponent(addFourteenMax.toISOString().split(".")[0]) +
    "%2B02%3A00";

const addThirtyMax = new Date();
addThirtyMax.setDate(current.getDate() + 30);
addThirtyMax.setUTCHours(23, 59, 59, 999);
export const addThirtyMaxString =
    encodeURIComponent(addThirtyMax.toISOString().split(".")[0]) +
    "%2B02%3A00";